'use strict';
require('../../modules/es.array.to-reversed');
var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('Array', 'toReversed');
